import { render, staticRenderFns } from "./NeedsMealModal.vue?vue&type=template&id=ac3b1392&lang=pug"
import script from "./NeedsMealModal.vue?vue&type=script&lang=ts"
export * from "./NeedsMealModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports